module.exports = __webpack_public_path__ + "static/media/shoes.c9f37eda.jpg";